import React, { useRef, useState } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

import { TTimelineSession } from '..';
import { TRow } from '../TimelineRow';
import Modal from '../../modules/Modal';
import { removeTopic } from '../../../api';
import { findSearchValue } from '../../../helpers';
import styles from './DeleteTimelineTopicModal.module.scss';
import { ContainedButton, OutlinedButton } from '../../modules/Buttons';
import { updateNotificationTrigger, updateSecondaySelectedClips } from '../../../store/sharedStore/sharedStoreSlice';
import { useAppDispatch } from '../../../store/hooks';
import { updateSortedSelectedClips } from '../../../store/videos/videoSlice';

type TTimelineTopicModal = {
  open: boolean;
  switchModal: () => void;
  fetchData: (forJson?: boolean) => Promise<any>;
  row: TRow;
  setSession: React.Dispatch<React.SetStateAction<TTimelineSession[]>>;
  fetchDataCallback?: () => void;
  changedTopicIdsRef: React.MutableRefObject<{
    oldTopicId?: number;
    newTopicId?: number;
  }>;
};

const DeleteTimelineTopicModal: React.FC<TTimelineTopicModal> = ({
  open,
  setSession,
  fetchData,
  switchModal,
  row,
  fetchDataCallback,
  changedTopicIdsRef,
}) => {
  const [loading, setLoading] = useState(false);
  const feedId = findSearchValue('feedId');
  const submitButtonRef = useRef<HTMLDivElement>(null);
  const onModalClose = () => {
    switchModal();
  };
  const dispatch = useAppDispatch();

  const handleDelete = async () => {
    setLoading(true);
    try {
      const { data } = await removeTopic({ id: +row.id }, +feedId!);
      if (data) {
        const { id, name, topicIndex, clips, topic_details } = data;
        await fetchData(true);
        setSession((prev) => [
          ...prev,
          {
            topic: {
              id,
              name,
              topicIndex,
              clips: [...clips],
              topicDetails: topic_details,
              status: 'deleted',
            },
          },
        ]);
      }
      if (fetchDataCallback) {
        fetchDataCallback();
      }
      dispatch(updateNotificationTrigger(Date.now()));
    } catch (err) {
      console.log(err);
      // @ts-ignore
      if (err?.response?.data?.message) {
        // @ts-ignore
        notification.showMessage(err?.response?.data?.message);
      }
    } finally {
      onModalClose();
      dispatch(updateSecondaySelectedClips([]));
      dispatch(updateSortedSelectedClips([]));
      setLoading(false);
    }
  };

  useHotkeys('Enter', () => {
    if (open && !loading) submitButtonRef?.current?.click();
  });

  return (
    <Modal open={open} onClose={onModalClose} loading={loading}>
      <div className={styles.modalBody}>
        <div className={styles.modalTitle}>
          Are you sure you want to delete <br /> "{row.name}" {row.clips.length ? 'with all the clips' : ''}
        </div>
        <div className={styles.form}>
          <div className={styles.actionBtns}>
            <OutlinedButton onClick={handleDelete} kind="default">
              <div ref={submitButtonRef}>Yes, I am sure</div>
            </OutlinedButton>

            <ContainedButton kind="purple" onClick={onModalClose}>
              No, cancel
            </ContainedButton>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteTimelineTopicModal;
